<div class="dialog-container">
  <div class="dialog-header">
    <h2 mat-dialog-title class="dialog-title">Invite Guests</h2>
    <p class="subtext">Choose what guests can do, then send it</p>
  </div>

  <button *ngIf="!isMobile" class="close-btn" type="button" (click)="close()">
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="20" fill="white" />
      <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="black" stroke-opacity="0.1" />
      <path d="M15.7578 15.7578L24.2431 24.2431" stroke="#131A26" stroke-width="1.5" stroke-linecap="round"
        stroke-linejoin="round" />
      <path d="M15.7569 24.2431L24.2422 15.7578" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>

  </button>
  <button *ngIf="isMobile" class="close-btn" type="button" (click)="goBack()">
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="20" fill="white" />
      <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="black" stroke-opacity="0.1" />
      <path d="M15.7578 15.7578L24.2431 24.2431" stroke="#131A26" stroke-width="1.5" stroke-linecap="round"
        stroke-linejoin="round" />
      <path d="M15.7569 24.2431L24.2422 15.7578" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>

  </button>
  <form [formGroup]="form">
    <div class="invite-section">
      <div class="left-panel">
        <div class="section">
          <h4>Guest settings</h4>
          <mat-checkbox formControlName="allowGuestUploads" (checked)="true" (change)="onSettingsChange()">Allow guest
            uploads</mat-checkbox>
        </div>

        <!-- Old "Guests settings" block. The albumType control stays in the
             FormGroup defaulted to 'all' (invite-dialog.component.ts), so the QR
             resolution in updateQRCode() is unaffected by hiding this; the
             'my-photos' option it offered was already disabled.
        <div class="section">
          <h4>Guests settings</h4>
          <mat-radio-group formControlName="albumType" (change)="onSettingsChange()" class="link-type-radio">
            <mat-radio-button value="my-photos" disabled>View photos of them only</mat-radio-button>
            <mat-radio-button value="all" (checked)="true">View all photos</mat-radio-button>
          </mat-radio-group>
        </div>
        -->

        <!-- <div class="section">
          <h4>Link Type</h4>
          <mat-radio-group formControlName="linkType" (change)="onSettingsChange()" class="link-type-radio">
            <mat-radio-button value="web">Web</mat-radio-button>
            <mat-radio-button value="app" *ngIf="hideMobile === false">Mobile App</mat-radio-button>
          </mat-radio-group>
        </div> -->


      </div>

      <div class="right-panel">
        <div class="qr-wrapper">
          <app-invite-card
            [eventName]="event_name || ''"
            [qrUrl]="cardQrUrl"
            [qrImage]="selectedQrCode"
            [canUpload]="canUpload">
          </app-invite-card>
          <div class="qr-buttons">
            <button mat-stroked-button (click)="downloadQR()">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                <path
                  d="M12.7208 16.506C12.6505 16.5829 12.565 16.6442 12.4697 16.6862C12.3744 16.7282 12.2714 16.7499 12.1673 16.7499C12.0631 16.7499 11.9601 16.7282 11.8648 16.6862C11.7695 16.6442 11.684 16.5829 11.6138 16.506L7.61377 12.131C7.4827 11.9837 7.41491 11.7907 7.42507 11.5938C7.43522 11.3969 7.52251 11.2119 7.66803 11.0789C7.81355 10.9459 8.0056 10.8755 8.20262 10.883C8.39965 10.8905 8.58579 10.9753 8.72077 11.119L11.4168 14.069V3C11.4168 2.80109 11.4958 2.61032 11.6364 2.46967C11.7771 2.32902 11.9679 2.25 12.1668 2.25C12.3657 2.25 12.5564 2.32902 12.6971 2.46967C12.8377 2.61032 12.9168 2.80109 12.9168 3V14.068L15.6138 11.118C15.7481 10.9712 15.9352 10.8838 16.134 10.875C16.3328 10.8662 16.527 10.9367 16.6738 11.071C16.8206 11.2053 16.908 11.3925 16.9168 11.5913C16.9256 11.7901 16.8551 11.9842 16.7208 12.131L12.7208 16.506Z"
                  fill="currentColor" />
                <path
                  d="M3.91675 15C3.91675 14.8011 3.83773 14.6103 3.69708 14.4697C3.55643 14.329 3.36566 14.25 3.16675 14.25C2.96784 14.25 2.77707 14.329 2.63642 14.4697C2.49577 14.6103 2.41675 14.8011 2.41675 15V15.055C2.41675 16.422 2.41675 17.525 2.53375 18.392C2.65375 19.292 2.91375 20.05 3.51475 20.652C4.11675 21.254 4.87475 21.512 5.77475 21.634C6.64175 21.75 7.74475 21.75 9.11175 21.75H15.2217C16.5887 21.75 17.6917 21.75 18.5587 21.634C19.4587 21.512 20.2167 21.254 20.8187 20.652C21.4207 20.05 21.6787 19.292 21.8007 18.392C21.9167 17.525 21.9167 16.422 21.9167 15.055V15C21.9167 14.8011 21.8377 14.6103 21.6971 14.4697C21.5564 14.329 21.3657 14.25 21.1667 14.25C20.9678 14.25 20.7771 14.329 20.6364 14.4697C20.4958 14.6103 20.4167 14.8011 20.4167 15C20.4167 16.435 20.4147 17.436 20.3137 18.192C20.2147 18.926 20.0337 19.314 19.7577 19.591C19.4807 19.868 19.0927 20.048 18.3577 20.147C17.6027 20.248 16.6017 20.25 15.1667 20.25H9.16675C7.73175 20.25 6.72975 20.248 5.97475 20.147C5.24075 20.048 4.85275 19.867 4.57575 19.591C4.29875 19.314 4.11875 18.926 4.01975 18.191C3.91875 17.436 3.91675 16.435 3.91675 15Z"
                  fill="currentColor" />
              </svg>
              <span> Save card</span>
            </button>
            <button mat-stroked-button (click)="shareInvite()">
              <svg width="17" height="21" viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.25 7.5H14.125C14.6223 7.5 15.0992 7.69754 15.4508 8.04917C15.8025 8.40081 16 8.87772 16 9.375V18.375C16 18.8723 15.8025 19.3492 15.4508 19.7008C15.0992 20.0525 14.6223 20.25 14.125 20.25H2.875C2.37772 20.25 1.90081 20.0525 1.54917 19.7008C1.19754 19.3492 1 18.8723 1 18.375V9.375C1 8.87772 1.19754 8.40081 1.54917 8.04917C1.90081 7.69754 2.37772 7.5 2.875 7.5H4.75M12.25 4.5L8.5 0.75M8.5 0.75L4.75 4.5M8.5 0.75V13.5469"
                  stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <span> Share invite</span>
            </button>
            <button mat-stroked-button (click)="copyLink()">
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 11.5C6 8.672 6 7.257 6.879 6.379C7.757 5.5 9.172 5.5 12 5.5H15C17.828 5.5 19.243 5.5 20.121 6.379C21 7.257 21 8.672 21 11.5V16.5C21 19.328 21 20.743 20.121 21.621C19.243 22.5 17.828 22.5 15 22.5H12C9.172 22.5 7.757 22.5 6.879 21.621C6 20.743 6 19.328 6 16.5V11.5Z" stroke="currentColor" stroke-width="1.5"/>
                <path d="M6 19.5C5.20435 19.5 4.44129 19.1839 3.87868 18.6213C3.31607 18.0587 3 17.2956 3 16.5V10.5C3 6.729 3 4.843 4.172 3.672C5.344 2.501 7.229 2.5 11 2.5H15C15.7956 2.5 16.5587 2.81607 17.1213 3.37868C17.6839 3.94129 18 4.70435 18 5.5" stroke="currentColor" stroke-width="1.5"/>
                </svg>
                
              <span> Copy Link</span>
            </button>
                 <!-- <button mat-stroked-button (click)="openUrl()">
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 11.5C6 8.672 6 7.257 6.879 6.379C7.757 5.5 9.172 5.5 12 5.5H15C17.828 5.5 19.243 5.5 20.121 6.379C21 7.257 21 8.672 21 11.5V16.5C21 19.328 21 20.743 20.121 21.621C19.243 22.5 17.828 22.5 15 22.5H12C9.172 22.5 7.757 22.5 6.879 21.621C6 20.743 6 19.328 6 16.5V11.5Z" stroke="currentColor" stroke-width="1.5"/>
                <path d="M6 19.5C5.20435 19.5 4.44129 19.1839 3.87868 18.6213C3.31607 18.0587 3 17.2956 3 16.5V10.5C3 6.729 3 4.843 4.172 3.672C5.344 2.501 7.229 2.5 11 2.5H15C15.7956 2.5 16.5587 2.81607 17.1213 3.37868C17.6839 3.94129 18 4.70435 18 5.5" stroke="currentColor" stroke-width="1.5"/>
                </svg>
                
              <span>Guest Url</span>
            </button> -->
          </div>

          <!-- For a host placing the code in their own artwork. Quiet on
               purpose: it is an escape hatch, not a fourth choice. -->
          <button type="button" class="plain-qr-link" (click)="downloadPlainQr()">
            Download plain QR
          </button>

        </div>
     
      </div>
    </div>

    <!-- The second way in, for guests who will never open a link. Full width
         under the panels rather than inside the 250px left column, and only on
         an upload invite — see showWhatsappUpload. Its own labelled section,
         separated from the Save/Share/Copy row above by a divider, so it never
         reads as one more thing bundled into that row. -->
    <div class="wa-section" *ngIf="showWhatsappUpload">
      <div class="wa-section-label">Invite guests to upload via WhatsApp</div>
      <div class="wa-upload">
        <span class="wa-upload-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413" />
          </svg>
        </span>
        <div class="wa-upload-text">
          <div class="wa-upload-sub">Photos guests message go straight to this album<ng-container *ngIf="whatsappUploadValidityLabel"> · Valid until {{ whatsappUploadValidityLabel }}</ng-container></div>
        </div>
        <button type="button" class="wa-upload-copy" (click)="copyWhatsappUpload()">
          {{ whatsappCopied ? 'Copied' : 'Copy' }}
        </button>
      </div>
    </div>

    <!-- Physical cards — behind its own flag since the designer dialog and
         the Canva links haven't been clicked through end to end yet. Grouped
         the same way as invite-share's printed-cards screen: a bordered row
         into the designer, then a horizontal strip of templates. -->
    <div class="printed-section" *ngIf="cardDesignerEnabled">
      <div class="section-label">Printed cards for the venue</div>

      <button type="button" class="printed-row" (click)="openCardDesigner()">
        <span class="printed-row-icon">
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
            <path d="M12 20h9M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </span>
        <span class="printed-row-text">
          <span class="printed-row-title">Design your own card</span>
          <span class="printed-row-sub">Build a custom layout — your QR code, your style</span>
        </span>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="printed-row-chevron">
          <path d="M9 6l6 6-6 6" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>

      <div class="canva-scroll">
        <button type="button" class="canva-tile" *ngFor="let t of cardTemplates" (click)="openCanvaTemplate(t)">
          <img [src]="t.previewImage" [alt]="t.title" onerror="this.src='assets/images/default_cover.png'" />
          <span class="canva-tile-title">{{ t.title }}</span>
        </button>
      </div>

      <button type="button" class="printed-see-all" (click)="goBrowseTemplates()">See all templates →</button>
    </div>
  </form>
  <!-- <app-storage-upgrade-banner style="display:block;padding:12px 0 4px;"></app-storage-upgrade-banner> -->
  <!-- The divider that used to sit here separated the form from the admin
       block below, which is commented out — it was ruling off empty space. -->
  <!--
<div class="invite-admins">
  <h4>Invite Admins</h4>
  <div class="admin-entry">
    <div class="avatar-badge">R</div>
    <input matInput placeholder="rajkumarrao@gmail.com" disabled />
    <mat-select [(value)]="adminRole" class="role-dropdown">
      <mat-option value="host">Host</mat-option>
      <mat-option value="admin">Admin</mat-option>
    </mat-select>
  </div>
  <button mat-icon-button class="add-admin">
    <mat-icon>add</mat-icon>
  </button>
</div> -->
</div>